import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CORE, CORE_JOB_EDUCATION_COURSE } from "../../../common/URLs";


export const fetchJobEducationCourse = async (selectedDegreeUuid) => {
  const url = `${BASE_URL}/${CORE}/${CORE_JOB_EDUCATION_COURSE}/${selectedDegreeUuid}`; // Proxy path 
  try { 
          const token = await fetchToken()
    
    const response = await fetch(url, { 
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    //   console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
return error }
};
export const fetchEducationCourse = async () => {
  const url = `${BASE_URL}/${CORE}/${CORE_JOB_EDUCATION_COURSE}`; // Proxy path
  try {
    const token = await fetchToken()

    const response = await fetch(url, { 
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    //   console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    // console.log("error", error);
    return error
  }
};

export const deleteJobEducationCourse = async (uuid) => {
  try {
    const token = await fetchToken()

    // console.log("uuid api", uuid)
    const response = await fetch(`${BASE_URL}/${CORE}/${CORE_JOB_EDUCATION_COURSE}/${uuid}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Error deleting job education course: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error deleting job education course", error);
    throw error;
  }
};



export const addJobEducationCourse = async (jobEducationCourseData) => {
  const url = `${BASE_URL}/${CORE}/${CORE_JOB_EDUCATION_COURSE}`; // Proxy path
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "accept": "application/json",
        "Content-type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(jobEducationCourseData),
    });
    const data = await response.json();
    // console.log("API Data", data);
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateJobEducationCourse  = async (uuid, jobEducationCourseData) => {
  // console.log("ID", id)
  try {
    const token = await fetchToken()

    const response = await fetch(`${BASE_URL}/${CORE}/${CORE_JOB_EDUCATION_COURSE}/${uuid}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(jobEducationCourseData),
    });

    const data = await response.json()
    // console.log("API Data", data);
    if (!response.ok) {
      throw new Error("Error updating job company: " + response.statusText);
    }

    return data;
  } catch (error) {
    throw new Error("Error updating job company: " + error.message);
  }
};
